const defaultState = () => ({
  cache: {},
  keepCache: {},
});

export const module = {
  namespaced: true,

  state: defaultState(),

  mutations: {
    setItem(state, { key, value }) {
      state.cache[key] = value;
      state.keepCache[key] = Date.now();
    },

    reset(state) {
      Object.assign(state, defaultState());
    },
  },
};

function getKeyFromArgs(options) {
  switch (typeof options) {
    case 'object':
      return JSON.stringify(options);
    case 'string':
    case 'number':
      return options;
    default:
      return undefined;
  }
}

function getKey(type, options) {
  const args = getKeyFromArgs(options);

  return (args && `${type}:${args}`) || type;
}

const Cache = {};

const requestCache = new Map();

Cache.install = function install(Vue, { store, moduleName = 'cache' }) {
  const keep = ms => ({
    async dispatch(type, options, ...args) {
      const key = getKey(type, options);
      const tempValue = requestCache.get(key);

      if (tempValue) {
        return tempValue;
      }

      const dispatchedOn = store.state[moduleName].keepCache[key];

      if (dispatchedOn && (!ms || Date.now() - dispatchedOn < ms)) {
        return store.state[moduleName].cache[key];
      }

      const request = store.dispatch(type, options, ...args);

      requestCache.set(key, request);

      try {
        store.commit(`${moduleName}/setItem`, { key, value: await request });
      } catch (e) {
        // do nothing I suppose?
      } finally {
        requestCache.delete(key);
      }

      return store.state[moduleName].cache[key];
    },
  });

  Vue.prototype.$cache = {
    keep,
    dispatch: keep(),
  };
};

export default Cache;
